module.exports = __webpack_public_path__ + "static/media/sl_logo.311264d5.svg";